export default __webpack_public_path__ + "static/media/phoneImg.68e930ba.svg";